export const techniciansList = {
  success: true,
  data: {
    items: [
      {
        technicianId: 1001,
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        hasThumbnail: true,
        photoUrl: '/photos/1001.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 2,
        role: 'Technician',
        location: 'North Branch',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1001,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:00:00Z',
          shiftEndTime: '2023-10-27T17:00:00Z',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1002,
        firstName: 'Jane',
        lastName: 'Baker',
        fullName: 'Jane Baker',
        hasThumbnail: false,
        photoUrl: null,
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 1,
        role: 'Senior Technician',
        location: 'Downtown Service Center',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1002,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1003,
        firstName: 'Bob',
        lastName: 'Chen',
        fullName: 'Bob Chen',
        hasThumbnail: true,
        photoUrl: '/photos/1003.jpg',
        hasUnreadMessages: true,
        hasPin: false,
        isPinSet: false,
        maintShopID: 3,
        role: 'Junior Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1003,
          hasActiveShift: true,
          hasActiveWorkOrders: false,
          hasIndirectLabor: true,
          shiftStartTime: '2023-10-27T09:00:00Z',
          shiftEndTime: '2023-10-27T18:00:00Z',
          isInOvertime: true,
        },
      },
      {
        technicianId: 1004,
        firstName: 'David',
        lastName: 'Lee',
        fullName: 'David Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1004,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1005,
        firstName: 'John',
        lastName: 'Lee',
        fullName: 'John Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1005,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:30:00Z',
          shiftEndTime: '2023-10-27T17:30:00Z',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1006,
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        hasThumbnail: true,
        photoUrl: '/photos/1001.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 2,
        role: 'Technician',
        location: 'North Branch',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1006,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:00:00Z',
          shiftEndTime: '2023-10-27T17:00:00Z',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1007,
        firstName: 'Jane',
        lastName: 'Baker',
        fullName: 'Jane Baker',
        hasThumbnail: false,
        photoUrl: null,
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 1,
        role: 'Senior Technician',
        location: 'Downtown Service Center',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1007,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1008,
        firstName: 'Bob',
        lastName: 'Chen',
        fullName: 'Bob Chen',
        hasThumbnail: true,
        photoUrl: '/photos/1003.jpg',
        hasUnreadMessages: true,
        hasPin: false,
        isPinSet: false,
        maintShopID: 3,
        role: 'Junior Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1008,
          hasActiveShift: true,
          hasActiveWorkOrders: false,
          hasIndirectLabor: true,
          shiftStartTime: '2023-10-27T09:00:00Z',
          shiftEndTime: '2023-10-27T18:00:00Z',
          isInOvertime: true,
        },
      },
      {
        technicianId: 1009,
        firstName: 'David',
        lastName: 'Lee',
        fullName: 'David Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1009,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1010,
        firstName: 'John',
        lastName: 'Lee',
        fullName: 'John Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1010,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:30:00Z',
          shiftEndTime: '2023-10-27T17:30:00Z',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1011,
        firstName: 'John',
        lastName: 'Anderson',
        fullName: 'John Anderson',
        hasThumbnail: true,
        photoUrl: '/photos/1001.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 2,
        role: 'Technician',
        location: 'North Branch',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1011,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:00:00Z',
          shiftEndTime: '2023-10-27T17:00:00Z',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1012,
        firstName: 'Jane',
        lastName: 'Baker',
        fullName: 'Jane Baker',
        hasThumbnail: false,
        photoUrl: null,
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 1,
        role: 'Senior Technician',
        location: 'Downtown Service Center',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1012,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1013,
        firstName: 'Bob',
        lastName: 'Chen',
        fullName: 'Bob Chen',
        hasThumbnail: true,
        photoUrl: '/photos/1003.jpg',
        hasUnreadMessages: true,
        hasPin: false,
        isPinSet: false,
        maintShopID: 3,
        role: 'Junior Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1013,
          hasActiveShift: true,
          hasActiveWorkOrders: false,
          hasIndirectLabor: true,
          shiftStartTime: '2023-10-27T09:00:00Z',
          shiftEndTime: '2023-10-27T18:00:00Z',
          isInOvertime: true,
        },
      },
      {
        technicianId: 1014,
        firstName: 'David',
        lastName: 'Lee',
        fullName: 'David Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: false,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'Off Shift',
        shiftDetails: {
          technicianId: 1014,
          hasActiveShift: false,
          hasActiveWorkOrders: false,
          hasIndirectLabor: false,
          shiftStartTime: '',
          shiftEndTime: '',
          isInOvertime: false,
        },
      },
      {
        technicianId: 1015,
        firstName: 'John',
        lastName: 'Lee',
        fullName: 'John Lee',
        hasThumbnail: true,
        photoUrl: '/photos/1004.jpg',
        hasUnreadMessages: true,
        hasPin: true,
        isPinSet: true,
        maintShopID: 3,
        role: 'Technician',
        location: 'West Side Location',
        status: 'On Shift',
        shiftDetails: {
          technicianId: 1015,
          hasActiveShift: true,
          hasActiveWorkOrders: true,
          hasIndirectLabor: false,
          shiftStartTime: '2023-10-27T08:30:00Z',
          shiftEndTime: '2023-10-27T17:30:00Z',
          isInOvertime: false,
        },
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 35,
      totalItems: 4,
      totalPages: 1,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    token: 'mock-access-token',
    totalCount: 15,
  },
  message: 'Security question retrieved successfully',
  errors: null,
  timestamp: '2026-02-04T17:45:00Z',
};

export const storesList = {
  success: true,
  data: {
    shops: [
      {
        maintShopID: '0',
        maintShop: 'All Shops',
        maintShopDesc: 'All Shops',
      },
      {
        maintShopID: '1',
        maintShop: 'Downtown Service Center',
        maintShopDesc: 'Downtown Service Center',
      },
      {
        maintShopID: '2',
        maintShop: 'North Branch',
        maintShopDesc: 'North Branch',
      },
      {
        maintShopID: '3',
        maintShop: 'South Branch',
        maintShopDesc: 'South Branch',
      },
    ],
    token: 'mock-access-token',
    success: true,
  },
  message: 'Security question retrieved successfully',
  errors: null,
  timestamp: '2026-02-04T17:45:00Z',
};
